import { render, staticRenderFns } from "./OCopyItemButton.vue?vue&type=template&id=47597db3&scoped=true&"
import script from "./OCopyItemButton.vue?vue&type=script&lang=js&"
export * from "./OCopyItemButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47597db3",
  null
  
)

export default component.exports